module.exports = __webpack_public_path__ + "img/knu_gallery6.a1b16c1c.jpg";